import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { familyMembersCollection } from 'app/src/msw/membership/initialSeed/familyMembers'
import type { membershipApi, UserFamilyMember } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const addFamilyMember = http.post<object, UserFamilyMember, membershipApi.FamilyMemberId | object>(
  apiBaseUrl + '/memberships/:membershipid/familyMembers',
  async ({ request }) => {
    const body = await request.json()
    console.log('Adding family member:', body)

    const createdFamilyMember = await familyMembersCollection.create({
      familyMemberId: Math.random().toString(36).substring(2, 15).toUpperCase(),
      fiscalCode: body.fiscalCode,
      lastName: body.lastName,
      relationship: body.relationship,
      taxDependent: body.taxDependent,
      firstName: body.firstName,
      signature: {
        signature: 'apg4ttFJviH74pyHxL45MjrzwXqHoVVDek51TrRmlPM',
        validUntil: 1729674566,
      },
    })

    console.log('Created family member:', createdFamilyMember)

    // if (body.firstName?.startsWith('BADREQUEST')) return HttpResponse.json(errorBadRequest, { status: 400 }) else
    return HttpResponse.json({ familyMemberId: createdFamilyMember.familyMemberId }, { status: 201 })
  },
)
